import { Comments } from "../../../../../../../../features/comments/components/comments/comments.component";
import { BasicResourceType } from "../../../../../../../../types/resources/resources.enums";
import { FlyerDetailPageFormProps } from "../flyer-detail-page-form/flyer-detail-page-form.props";

export const FlyerDetailPageComments = (props: FlyerDetailPageFormProps) => (
  <Comments modelId={props.pageId} modelName={BasicResourceType.FlyerPage} />
);
